export const groupBy = <T>(array: T[] | undefined, property: keyof T): Record<string | number, T[]> => {
  return (
    array?.reduce((acc, obj) => {
      const key = obj[property] as unknown as string | number;

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(obj);
      return acc;
    }, {} as Record<string | number, T[]>) ?? {}
  );
};
